<template>
  <div>
    <ion-header>
      <ion-toolbar>
        <ion-title>
          {{ location.name }}: Start Order {{ order.friendlyIdentifier() }}
        </ion-title>
        <ion-buttons slot="end">
          <ion-button @click="closeModal()">Close</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-list>
        <ion-item
          v-for="(lineItem, index) in order.items"
          :key="`item-${index}`"
          :data-cy="`order-item-${lineItem.id}`"
        >
          <ion-text slot="start">
            {{ lineItem.quantity }}
          </ion-text>
          <ion-label>
            {{ lineItem.name }}
            <span v-if="lineItem.options">
              - {{ lineItem.options.value.name }}
            </span>
            <p v-if="lineItem.instructions">{{ lineItem.instructions }}</p>
          </ion-label>
        </ion-item>
      </ion-list>
      <div v-if="order.instructions">
        <strong>Instructions:</strong> {{ order.instructions }}
      </div>
      <hr />
      <hr />
      <div class="ion-text-center">
        <div class="large-confirm">
          Please confirm you're ready to start this order and prepare it.
        </div>
        <hr />
        <ion-button color="success" size="full" @click="startOrder()">
          Yes, Start Order
        </ion-button>
        <hr />
        <ion-button color="danger" size="small" @click="closeModal()">
          Nope
        </ion-button>
      </div>
      <hr />
      <ion-text color="primary">
        When you start an order, the customer will receive a status update
        informing them you've began your work.
      </ion-text>
    </ion-content>
  </div>
</template>

<script>
export default {
  props: {
    closeModal: {
      required: true,
      type: Function
    },
    startOrder: {
      required: true,
      type: Function
    },
    location: {
      required: true,
      type: Object
    },
    order: {
      required: true,
      type: Object
    }
  }
};
</script>

<style lang="scss">
.large-confirm {
  font-size: 1.2rem;
  font-weight: bold;
}
</style>
